import I18n from 'I18n';
import { toPropertyBasicType } from '../../../../../dataset/type-utils';
import { useExpressionField, useExpressionFields, useMeta
// @ts-expect-error untyped import
} from '../SourceMeta';
import { checkExpressionField } from '../../../../utils/expression-field-utils';
export const useGetExpressionFilterErrorTooltipMessage = filter => {
  const {
    field
  } = filter;
  const expressionField = useExpressionField(field.name);
  const expressionFieldList = useExpressionFields();
  const meta = useMeta();
  if (!expressionField) {
    return I18n.text('reporting-snowflake.filter-editor.expression-field.invalid-expression');
  }
  const isValidType = toPropertyBasicType(expressionField.type) === field.type;
  const {
    violations
  } = checkExpressionField(expressionField, expressionFieldList, meta);
  const isValidExpressionField = !violations || violations.size === 0;
  const errorTooltipMessage = !isValidType ? I18n.text('reporting-snowflake.filter-editor.expression-field.invalid-type') : !isValidExpressionField ? I18n.text('reporting-snowflake.filter-editor.expression-field.invalid-expression') : null;
  return errorTooltipMessage;
};